import { Box, BrandIcon, Row, Text, Tooltip } from "@hightouch/htui";

import { COMPOSER_TEXT_INSET_PX } from "src/components/llm/components/compact-chat-input-layout";
import type { PageBrand } from "src/components/llm/agent-focus/agent-focus";

const BRAND_LIST_FORMAT = new Intl.ListFormat("en", { type: "conjunction" });

type BrandScopePillProps = {
  /** The names of the brands the composer's options are limited to. */
  names: string[];
  /** The kind of page whose brand sets the scope; absent when the picks set it. */
  page?: PageBrand["page"];
};

/** A cue above the composer naming the brands its options are limited to, lined up with the composer's text. */
export function BrandScopePill({ names, page }: BrandScopePillProps) {
  const label = names.length === 1 ? names[0] : `${names.length} brands`;
  const list = BRAND_LIST_FORMAT.format(names);
  return (
    <Row pl={`${COMPOSER_TEXT_INSET_PX}px`} textAlign="left">
      <Tooltip
        message={
          page
            ? `Options below are scoped to the ${page} brand.`
            : names.length === 1
              ? "Options below are scoped to your selection's brand."
              : `Options below are scoped to your selection's brands: ${list}.`
        }
        placement="top"
      >
        <Row align="center" gap={1} minWidth={0} color="text.tertiary">
          <Box as={BrandIcon} boxSize={4} flexShrink={0} />
          <Text size="sm" color="text.tertiary" isTruncated>
            {label}
          </Text>
        </Row>
      </Tooltip>
    </Row>
  );
}
